export default __webpack_public_path__ + "b6147ab822dbaefec07f2a55c5ccaeeb.woff2";